import ScanTeamButton from './ScanTeamButton.vue';
export default ScanTeamButton;
